<template>
	<div class="create-pool-page">
		<div class="create-pool-page__content">
			<form @submit.prevent="onSubmit" class="create-pool-form">
				<h3 class="header">Create a Pool</h3>
				<div class="form-group">
					<select id="league" class="select-input input--primary font-size--medium" required v-model="selectedLeague" :disabled="!authenticated" :class="{'select-disabled': !authenticated }">
						<option value="League" disabled>Choose a League</option>
						<option v-for="(league, index) in leagues" :key="league.id" :value="index">{{ league.name }}</option>
					</select>
					<div class="requirements" v-if="leagueRequired">
						<ul>
							<li>Please make a selection</li>
						</ul>
					</div>
				</div>
				<div class="form-group">
					<select id="event" class="select-input input--primary font-size--medium" :class="{ 'select-disabled': eventDisabled }" required v-model="selectedEvent" :disabled="!authenticated">
						<option value="Event" disabled>Choose an Event</option>
						<option v-for="(event, index) in events" :key="event.id" :value="index">{{ event.name }}</option>
					</select>
					<div class="requirements" v-if="eventRequired">
						<ul>
							<li>Please make a selection</li>
						</ul>
					</div>
				</div>
				<div class="form-group">
					<select id="game" class="select-input input--primary font-size--medium" :class="{ 'select-disabled': gameDisabled }" required v-model="selectedGame" :disabled="!authenticated">
						<option value="Game" disabled>Choose a Game</option>
						<option v-for="(game, index) in games" :key="game.id" :value="index">{{ game.name }}</option>
					</select>
					<div class="requirements" v-if="gameRequired">
						<ul>
							<li>Please make a selection</li>
						</ul>
					</div>
				</div>
				<div class="form-group">
					<input class="text-input input--primary font-size--medium" type="text" placeholder="Pool Name" v-model="poolName" required :disabled="!authenticated">
				</div>
				<div class="form-group" v-if="showNumberOfBrackets">
					<input class="text-input input--primary font-size--medium" type="number" placeholder="# of Brackets Allowed Per User" v-model="numberOfBracketsAllowed" required min="1" max="10">
				</div>
				<div class="form-group" v-if="authenticated">
					<input class="btn btn--form-submit font-size--medium" type="submit" value="Create Pool">
				</div>
			</form>
			<div class="logged-out" v-if="!authenticated">
				<button class="auth-button auth-button--primary" @click="SET_LOGIN_REGISTER(true)">Please Login or Signup!</button>
			</div>
		</div>
	</div>
</template>

<script>
	import { mapGetters, mapMutations, mapActions } from 'vuex'
	import axios from '../axios'

	export default {
		data() {
			return {
				selectedLeague: 'League',
				selectedEvent: 'Event',
				selectedGame: 'Game',
				poolName: '',
				numberOfBracketsAllowed: '',
				leagueRequired: false,
				eventRequired: false,
				gameRequired: false,
			}
		},
		computed: {
			...mapGetters([
				'user',
				'leagues',
				'authenticated'
			]),
			eventDisabled() {
				return this.selectedLeague == 'League'
			},
			events() {
				if(this.selectedLeague == 'League') {
					return []
				} else {
					return this.leagues[this.selectedLeague].available_events
				}
			},
			gameDisabled() {
				return this.selectedEvent == 'Event'
			},
			games() {
				if(this.selectedEvent == 'Event') {
					return []
				} else {
					return this.leagues[this.selectedLeague].available_events[this.selectedEvent].available_games
				}
			},
			showNumberOfBrackets() {
				if(this.selectedGame == 'Game') {
					return false
				} else {
					return this.leagues[this.selectedLeague].available_events[this.selectedEvent].available_games[this.selectedGame].multiple_entries_allowed
				}
			}
		},
		methods: {
			...mapMutations([
				'HTTP_IN_PROGRESS',
				'HTTP_FINISHED',
				'SET_LOGIN_REGISTER'
			]),
			...mapActions([
				'getCurrentPools'
			]),
			onSubmit() {
				if(this.selectedLeague == 'League') {
					this.leagueRequired = true
					return
				}
				if(this.selectedEvent == 'Event') {
					this.eventRequired = true
					return
				}
				if(this.selectedGame == 'Game') {
					this.gameRequired = true
					return
				}

				this.HTTP_IN_PROGRESS()
				var data = {
					game_id: this.leagues[this.selectedLeague].available_events[this.selectedEvent].available_games[this.selectedGame].id,
					event_id: this.leagues[this.selectedLeague].available_events[this.selectedEvent].id,
					name: this.poolName,
				}

				if(this.showNumberOfBrackets) {
					data['number_of_brackets_allowed'] = this.numberOfBracketsAllowed
				}
				
				axios.post(this.leagues[this.selectedLeague].available_events[this.selectedEvent].available_games[this.selectedGame].api_path, data).then(response => {

					this.getCurrentPools().then(() => {
						this.$router.replace({ name:  'manage-' + this.leagues[this.selectedLeague].available_events[this.selectedEvent].available_games[this.selectedGame].api_path, params: { poolId: response.data.data.id }})
					})

				})
			}
		},
		watch: {
			selectedGame: function() {
				this.gameRequired = false
			},
			selectedLeague: function() {
				this.selectedEvent = 'Event'
				this.leagueRequired = false
			},
			selectedEvent: function() {
				this.selectedGame = 'Game'
				this.eventRequired = false
			}
		}
	}
</script>

<style lang="scss">
	@import '../styles/app';
	@import '../styles/views/createPool';
</style>